import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../../../components/fields/Switches/Switches';
import JuridicalDTO from '../../../../../dto/JuridicalDTO';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';

export default function OgrnForm(props) {
  const {
    prefix = 'applicant_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showOgrn, setOgrn] = useState(
    isEdit ? !!currentApplication?.applicant_new?.ogrn || currentApplication?.applicant_new?.ogrn === null : false,
  );

  const dto = new JuridicalDTO({ optional: true, legal_entity_type: applicantType });
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.ogrn', !showOgrn ? null : (isEdit ? getValues('applicant_new.ogrn') || '' : ''));
    if (!showOgrn) setValue('media.ogrn_change_document', null);
  }, [showOgrn]);

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setOgrn(!showOgrn),
              value: showOgrn,
            }}
            label="Изменился ОГРН"
          />
        </Col>
      </Row>
      {showOgrn && (
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.ogrn}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.ogrn_change_document}
            variant="material"
            namePrefix="media."
          />
        </Row>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
